import { Draggable } from "@hello-pangea/dnd";
import React from "react";
import { TabItem } from "../types";
import { Tab } from "../Tab";

interface DraggableTabProps {
  tab: TabItem;
  index: number;
  currentIndex: number;
  handleTabChange?: (tabId: number) => void;
}

const DraggableTab: React.FC<DraggableTabProps> = ({
  tab,
  index,
  currentIndex,
  handleTabChange,
}) => {
  return (
    <Draggable draggableId={`tab-${tab.id}`} index={index}>
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={`[data-rbd-draggable-id]:left-auto [data-rbd-draggable-id]:right-auto select-none ${
              snapshot.isDragging ? "z-50" : ""
            }`}
          >
            <Tab
              tab={tab}
              index={index}
              currentIndex={currentIndex}
              handleTabChange={handleTabChange}
              isDragging={snapshot.isDragging}
            />
          </div>
        );
      }}
    </Draggable>
  );
};

export default DraggableTab;
